import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import './Slideshow.css';
import { Link } from 'react-router-dom';

const Slideshow = () => {


    return (
        <Slide>
            <Link style={{ color: 'inherit', textDecoration: 'none' }} to={"/post/a3546dfjkn4321"}>
                <div className="each-slide-effect">
                    <div className='a3546dfjkn4321'>
                        <span>تصاویر منتشر نشده از حضور حاج قاسم در خوزستان</span>
                    </div>
                </div>
            </Link>
            <Link style={{ color: 'inherit', textDecoration: 'none' }} to={"/post/g98bhfj575322"}>
                <div className="each-slide-effect">
                    <div className='g98bhfj575322'>
                        <span>حضور سردار سلیمانی در مناطق سیل زده خوزستان</span>
                    </div>
                </div>
            </Link>
            <Link style={{ color: 'inherit', textDecoration: 'none' }} to={"/post/d35f2mn4gdf53"}>
                <div className="each-slide-effect">
                    <div className='d35f2mn4gdf53'>
                        <span>
                            تشییع پیکر سردار سلیمانی در اهواز</span>
                    </div>
                </div>
            </Link>


        </Slide>
    );
};

export default Slideshow;